module.exports = __webpack_public_path__ + "img/ea5dfeb.png";